import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal,
  List,
  Typography,
  Row,
  Col,
  Checkbox,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import padronToString from 'utils/padronesToString';
import { SET_PADRON_REQUIERE_FETCH } from 'store/reducers/caja';

const ModalPadronesAConsultarAdeudo = ({ visible, onCancel }) => {
  const dispatch = useDispatch();
  const padrones = useSelector(({ caja }) => caja.padrones).map((padron) => ({
    title: padronToString(padron, padron.tipo_de_padron),
    key: padron.key,
  }));
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (visible) {
      setSelectedItems(padrones.map((p) => p.key));
    }
  }, [visible]);

  const onFinish = () => {
    selectedItems.forEach((padron) => {
      dispatch({
        type: SET_PADRON_REQUIERE_FETCH,
        payload: padron,
      });
    });
    onCancel();
  };

  const onSelect = (key) => {
    if (selectedItems.includes(key)) {
      setSelectedItems(selectedItems.filter((e) => e !== key));
    } else {
      setSelectedItems([...selectedItems, key]);
    }
  };

  return (
    <Modal
      title={(
        <FormSubmitControls
          label="Consultar adeudo"
          onCancel={onCancel}
          onFinish={onFinish}
          onFinishText="Consultar"
        />
      )}
      visible={visible}
      footer={null}
      closable={false}
    >
      <Typography.Text>
        El ciudadano cuenta con varios padrones.
        Seleccione los padrones de los cuales quiere consultar el adeudo.
      </Typography.Text>
      <br />
      <Typography.Text>
        De igual manera podrá realizar la consulta más adelante si lo desea.
      </Typography.Text>
      <br />
      <br />
      <Typography.Title level={5}>
        Padrones
      </Typography.Title>
      <List
        dataSource={padrones}
        renderItem={(padron, idx) => (
          <List.Item
            onClick={() => (idx === 0 ? null : onSelect(padron.key))}
            style={{ cursor: idx === 0 ? 'not-allowed' : 'pointer' }}
            className={idx === 0 ? 'disabled' : null}
          >
            <Row style={{ width: '100%', padding: '0 5px' }}>
              <Col flex="auto">
                <Typography.Text>
                  {padron.title}
                </Typography.Text>
              </Col>
              <Col>
                <Checkbox
                  checked={selectedItems.includes(padron.key)}
                  onClick={() => onSelect(padron.key)}
                  disabled={idx === 0}
                />
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </Modal>
  );
};
ModalPadronesAConsultarAdeudo.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

ModalPadronesAConsultarAdeudo.defaultProps = {
  visible: false,
};

export default ModalPadronesAConsultarAdeudo;
